const textTransform = {
    name: "text-transform",
    path: "/text-transform",
    title: "text-transform",
    description: "Utilities for controlling the capitalization of text.",
    value: {
        "text-transform": {
            "uppercase": "uppercase",
            "lowercase": "lowercase",
            "capitalize": "capitalize",
            "normal-case": "none"
        }
    },
    exampleData: [
        {
            example: {
                code: `
<p class="uppercase">This text is uppercase.</p>
<p class="lowercase">THIS TEXT IS LOWERCASE.</p>
<p class="capitalize">this text is capitalized.</p>
<p class="normal-case">This text is normal.</p>
        `
            }
        }
    ],
    htmlData: [
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">uppercase</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">lowercase</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">capitalize</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">normal-case</code> to control the capitalization of text.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">uppercase</small>
          <p class="uppercase text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">lowercase</small>
          <p class="lowercase text-lg">THE QUICK BROWN FOX JUMPS OVER THE LAZY DOG.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">capitalize</small>
          <p class="capitalize text-lg">the quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">normal-case</small>
          <p class="normal-case text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
        }
    ]
};

export default textTransform;
<div className="uppercase lowercase capitalize normal-case sr-only"></div>